// extracted by mini-css-extract-plugin
export default {"outer":"style_outer__vbHB9__WHx6O"};